import { useAuthStore } from './auth.ts';
import { pinia } from './pinia.js';

const authStore = useAuthStore(pinia);

export const initializeAuth = async () => {
  if (!authStore.isInitialized) {
    try {
      const isAuthenticated = await authStore.initialize();
      return { ...authStore, isAuthenticated };
    } catch (error) {
      console.error('Auth initialization error:', error);
      return { ...authStore, isAuthenticated: false };
    }
  }
  return authStore;
};

export { authStore };
